import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { LegalTransactionOverview } from '../private/LegalTransaction/LegalTransactionOverview';

import { IConfig } from '../../Interfaces/IConfig';
import { DownloadArea } from '../private/DonwloadArea/DownloadArea';

import { ClientEdit } from '../private/Client/ClientEdit';
import InvitationsMain from '../private/Invitations/InvitationsMain';
import Layout from '../private/Layout';

interface IProps {
  configObject: IConfig;
}

export const PageRouter: React.FC<IProps> = ({ configObject }) => {
  return (
    <>
      <Router>
        <Layout configObject={configObject}>
          <Routes>
            <Route
              index
              element={<LegalTransactionOverview configObject={configObject} />}
            />
            <Route
              path='/:idLegalTransaction'
              element={<LegalTransactionOverview configObject={configObject} />}
            />
            <Route
              path='/:idLegalTransaction/:view'
              element={<LegalTransactionOverview configObject={configObject} />}
            />
            <Route path='/account' element={<ClientEdit />} />
            <Route path='/download_area' element={<DownloadArea />} />
            <Route path='/invitations' element={<InvitationsMain />} />
          </Routes>
        </Layout>
      </Router>
    </>
  );
};
